import { Box } from "@mui/material";
import Loader from "components/Loader/Loader";
import TableMonitoring from "components/TableMonitoring";
import NoDataTableBody from "components/TableMonitoring/Body/NoDataTableBody";
import EditMenuOption from "components/TableMonitoring/Body/RowMenuListActions/EditMenuOption";
import TableRowStatic from "components/TableMonitoring/Body/TableRowStatic";
import TableHeaderStatic from "components/TableMonitoring/Header/Static/TableHeaderStatic";
import { organizationsTexts } from "locale/es";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import DrawerHeader from "components/DrawerHeader";
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs";
import { useFilter } from "hooks/useFilter";
import { useFilterContext } from "context/FilterContext";
import { OrganizationsTableRows } from "./OrganizationsTableRows";
import DeleteMenuOption from "components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption";
import { initializeOrganizations } from "redux/reducers/organizationsReducer";
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import FilterTable from "components/TableMonitoring/Toolbar/Filter";

const tableHeaders = [
  { name: organizationsTexts.NAME, value: "name" },
  { name: organizationsTexts.CLAIM, value: "claim" },
  { name: organizationsTexts.LOGO, value: "logoUrl" },
  { name: organizationsTexts.MERCHANT, value: "merchant" },
  { name: organizationsTexts.MERCHANTLOGO, value: "merchantLogoUrl" },
];

export function OrganizationsTable() {
  const { data, loading, error } = useSelector(
    ({ organizations }) => organizations
  );
  const { selectedFilter, searchTerm } = useFilterContext();

  const dispatch = useDispatch();

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  useEffect(() => {
    dispatch(initializeOrganizations());
  }, [dispatch]);

  if (loading) {
    return <Loader message={organizationsTexts.LOADER} pt={32} />;
  }

  if (!data) return null;

  return (
    <Box component='main' sx={{ flex: 1, p: 3, mb: 20 }}>
      <DrawerHeader />
      <BreadCrumbs
        name={organizationsTexts.BREADCRUMBS}
        icon={<CorporateFareOutlinedIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
      />
      <Box mt={4} sx={{ minWidth: "100%" }}>
        <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              entity={data}
              canCreate
            />
          }
        >
          {(selectedFilter && !searchTerm ? data : filteredData).map(
            (organization) => (
              <TableRowStatic
                key={organization.id}
                entity={organization}
                loaded={!loading}
                actions={
                  <Box>
                    <EditMenuOption entity={organization} />
                    <DeleteMenuOption entityId={organization.id} />
                  </Box>
                }
              >
                <OrganizationsTableRows organization={organization} />
              </TableRowStatic>
            )
          )}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            selectedEntity={true} // ? Is this necessary?
            noDataMessage={organizationsTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={data}
            noDataMessage={organizationsTexts.NO_DATA_FILTERS}
          />
        )}
      </Box>
      <Outlet />
    </Box>
  );
}

